// Mount the Aes module: build its host from what only this app can supply and hand it to
// `createAesModule`. `service-modules.ts` and `service-scopes.ts` take the routes and the catalog
// scope from HERE, so the module cannot be mounted unregistered. The HTTP clients are not members:
// the module reads them from the shared registry (`@vnetwork/margarita-core/http`).
import { env } from '@/config/env';
import { createAesModule, type AesHost } from '@vnetwork/margarita-aes';
import { withHostBase } from './host-base';

const host: AesHost = withHostBase(['trackFeatureAction'], {
  controlApiUrl: env.controlApiUrl,
  aesGatewayHost: env.aesGatewayHost,
});

export const aes = createAesModule(host);
